import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import { fromJS } from "immutable";
import rootReducer from "./reducers";
import { mapStoreToLocalStorage } from "./storePersistent";
import { saveState } from "common/utils/localStorage";
import { createBrowserHistory } from "history";

const sagaMiddleware = createSagaMiddleware();
export const history = createBrowserHistory();

export default function configureStore(initialState = {}) {
  // Create the store with middlewares
  const middlewares = [sagaMiddleware, logger];

  const enhancers = [applyMiddleware(...middlewares)];

  const composeEnhancers =
    process.env.NODE_ENV !== "production" &&
    typeof window === "object" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;

  const store = createStore(
    rootReducer(),
    fromJS(initialState),
    composeEnhancers(...enhancers)
  );

  // Listen to route changes and dispatch actions
  history.listen((location, action) => {
    store.dispatch({ type: "ROUTE_CHANGED", payload: location.pathname });
  });

  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.asyncReducers = {}; // Async reducer registry
  store.subscribe(() => {
    saveState(mapStoreToLocalStorage()(store.getState()));
  });

  return { store, history };
}
